import { render, staticRenderFns } from "./SecondaryNavigation.vue?vue&type=template&id=813ba276&scoped=true"
import script from "./SecondaryNavigation.vue?vue&type=script&lang=js"
export * from "./SecondaryNavigation.vue?vue&type=script&lang=js"
import style0 from "./SecondaryNavigation.vue?vue&type=style&index=0&id=813ba276&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813ba276",
  null
  
)

export default component.exports